// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CmbW","type":"styles_type__26Q44","choices":"styles_choices__l2IUc"};